import { useEffect } from 'react'
import DeclinedPermissions from './routes/declined'
import Landing from './routes/landing'
import { Route, useLocation, Routes, Outlet, useNavigate } from 'react-router'
import { parse } from 'query-string'
import Loader from 'components/SimpleLoader'
import { IndexedObject, User } from 'interfaces'
import { connect, useDispatch } from 'react-redux'
import { StoreThunkDispatch } from 'store/state'
import { continueWithFacebookLogin } from 'services/auth/identities/facebook'

import styles from './Login.pcss'
import { message } from 'services/snackbar'
import { useIntl } from 'react-intl'
const FB_TOKEN_QUERY_KEY = 'fb_access_token'

interface ConnectedLoginProps {
  loginWithFbToken: (token: string, params?: { [key: string]: string }) => Promise<User>
}
export type LoginProps = ConnectedLoginProps

export function Login(props: LoginProps) {
  const dataLayer = (window as any).dataLayer || [] // Google Tag Manager dataLayer
  const dispatch = useDispatch()
  const intl = useIntl()
  const location = useLocation()
  const navigate = useNavigate()
  const { loginWithFbToken } = props
  const loginParams: { [key: string]: string } = parse(location.search) as IndexedObject<string>

  useEffect(() => {
    const params: { [key: string]: string } = parse(location.search) as IndexedObject<string>
    const fbToken = params[FB_TOKEN_QUERY_KEY]

    if (params?.ott) {
      dataLayer.push({ 'event': 'pp.login' })
    }

    if (fbToken) {
      loginWithFbToken(fbToken, params)
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log('Login error: ', error)
          dispatch(message(intl.formatMessage({ id: 'errors.generic-support' }), 'error'))
          navigate('/login')
        })
    }
  }, [dispatch, intl, location.search, loginWithFbToken, navigate])

  if (loginParams.fb_access_token) {
    return (
      <Loader title="logging in..." />
    )
  }

  return (
    <main data-test="login" className={styles.login}>
      <Outlet />
    </main>
  )
}

function mapDispatchToProps(dispatch: StoreThunkDispatch) {
  return {
    loginWithFbToken: (token: string, params?: { [key: string]: string }) => {
      const response = {
        authResponse: {
          accessToken: token
        }
      } as any
      return dispatch(continueWithFacebookLogin(response, false, params))
    }
  }
}

export default connect(null, mapDispatchToProps)(Login)
